import { Component, OnInit, OnDestroy } from '@angular/core';
import {formatDate} from '@angular/common';
import { Subscription } from 'rxjs';

import { ProjectsService, ProjectsEditorService } from '@app/services/app/projects.service';

import * as Objects from '@core/objects';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';
import { NotificationsService } from '@core/services/notifications/notifications.service';


@Component({
    selector: 'project-details-info-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss']
})
export class ProjectDetailsInfoDetailsComponent implements OnInit, OnDestroy { 
    public readonly ACCESS_UPLOAD_FILE = "access_request_upload_file";

    public accessUpload: boolean = false;
    public showUpload: boolean = false;
    public project: Objects.Request = null;
    public menu: Array<ThreeDotsMenuItem> = [];
    protected menuDownload: ThreeDotsMenuItem = {
        title: "Download All Files",
        key: "download-all",
        icon: "download",
        order: 1
    };
    protected menuUpload: ThreeDotsMenuItem = {
        title: "Attach Files",
        key: "upload",
        icon: "upload-file",
        order: 2
    };
    protected subs: Subscription = new Subscription();
	constructor(
        private projectsSrv: ProjectsService,
        private editorSrv: ProjectsEditorService, 
        private notifSrv: NotificationsService
    ){}

    ngOnInit(){ 
        this.subs.add(this.projectsSrv.selectProject().subscribe((project: Objects.Request ) => {
            if(project != null)
                this.project = project;
        }));

        this.subs.add(this.projectsSrv.selectProjectFiles().subscribe((files: Objects.AmsFile[] ) => {
            if(files != null && files.length > 0){
                this.updateMenu(this.menuDownload);
            }
        }));

        this.subs.add(this.editorSrv.selectAccess(this.ACCESS_UPLOAD_FILE)
        .subscribe((access: boolean) => {
            this.accessUpload = access;
            this.updateMenu(this.menuUpload,this.accessUpload);
        }));
	}

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    onUploadDone(event: any){
        if(!this.accessUpload)
            return;

        this.showUpload = !this.showUpload;
    }

    onMenuClick(key: string) {
        switch(key) {
            case "download-all":
                // start notification to download compressed project files in zip
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILES_COMPRESSION_START, {id: this.project.id, details: { url: "/requests/"+this.project.id }});
                break;
            case "upload":
                // console.debug(" open upload click on files ", key)
                if(!this.accessUpload)
                    break;

                this.showUpload = !this.showUpload;
                break;
        }
    }

    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }
}